import React from "react"
import {render} from "react-dom"
import find from "array.prototype.find"
import allSettledPoly from "promise.allsettled"
import {Router} from "react-router-dom"

import History from "@irati/utils/history"
import {ThemeProvider} from "@irati/ui/src/global/useTheme"
import {STAGING, PRODUCTION, E2E} from "@irati/utils/constants/environment"
import {logBanner, sendSlackConsoleComms} from "@irati/utils/console/banner"
import googleTagManager from "@irati/utils/services/googleTagManager"
import coview from "@irati-web/platform/src/utils/coview"
import intlPolyfill from "@irati/utils/lang/polyfill"
import tracking from "@irati/utils/tracking"
import env from "@irati/utils/env"
// various 3rd parties
import sentry from "@irati/utils/services/sentry"
import "@irati/utils/intercom"
import "@irati/braze"

import App from "./routes/index"

// Global css
import "react-table/react-table.css"
import "../public/css/react-table.css"
import "react-redux-toastr/lib/css/react-redux-toastr.min.css"

if ([STAGING, PRODUCTION, E2E].indexOf(env.ENVIRONMENT_NAME) > -1) {
  /** Console log logo banner when in pipeline for hires */
  window.hireMe = sendSlackConsoleComms
  logBanner()
}

tracking.setup(env.ENVIRONMENT_NAME)
coview.setup()
googleTagManager.setup()

/** polyfill for IE11: Scoon isn't sure if we need this */
find.shim()
// polyfill promise.allSettled
allSettledPoly.shim()

intlPolyfill(() => {
  sentry.context(() => {
    /** Start the app */
    render(
      <Router history={History}>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </Router>,
      document.getElementById("root")
    )
    if (module.hot) module.hot.accept()
  })
})

// Handle outlines for mouse / keyboard users
document.body.addEventListener("keyup", function (e) {
  if (e.which === 9) {
    /* tab */ document.documentElement.classList.remove("no-focus-outline")
  }
})

document.body.addEventListener("mousedown", function () {
  document.documentElement.classList.add("no-focus-outline")
})
